import { useMutation } from '@tanstack/react-query';
import apiService from '../services/apiService';

export const useAddManualBlockedDate = () => {
  const formatDateLocal = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return useMutation({
    mutationFn: async ({ propertyId, startDate, endDate }) => {
      const startDateStr = formatDateLocal(startDate);
      const endDateStr = formatDateLocal(endDate);
      
      const payload = {
        property_id: propertyId,
        startDate: startDateStr,
        endDate: endDateStr,
      };
      
      const response = await apiService.post(
        '/api/properties/manual-blocked-dates',
        payload
      );
      return response.data;
    },
  });
};
